module.exports = __webpack_public_path__ + "logo-footer.png";